var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransporteur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4342 -5.76511e-05H5.56753C4.97895 -0.00102662 4.40897 0.206117 3.95835 0.58476C3.50773 0.963403 3.20549 1.48916 3.10503 2.06911L-0.0324707 19.9999H20.0509L16.8967 2.06661C16.7948 1.48756 16.492 0.962948 16.0417 0.584978C15.5913 0.207008 15.0221 -0.000138072 14.4342 -5.76511e-05ZM1.95086 18.3333L4.75003 2.35661C4.78367 2.16395 4.88399 1.98926 5.03345 1.86312C5.1829 1.73697 5.37196 1.66741 5.56753 1.66661H14.4342C14.6302 1.66659 14.82 1.73568 14.9701 1.86173C15.1202 1.98777 15.2211 2.16271 15.255 2.35578L18.0659 18.3333H1.95086ZM9.1667 3.33328H10.8334V6.66661H9.1667V3.33328ZM9.1667 8.33328H10.8334V11.6666H9.1667V8.33328ZM9.1667 13.3333H10.8334V16.6666H9.1667V13.3333Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteur);
export default __webpack_public_path__ + "static/media/transporteur.9bf85cc1.svg";
export { ForwardRef as ReactComponent };